import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';

// レスポンス構造
export type GetPastImageInfoResponse = {
  ImageFileName: string;
  ImagePreviewUrl: string;
  ImageId: string;
};

/**
 * 画面再表示時の情報取得するサービス
 *
 * @export GetPastImageInfoService
 * @class GetPastImageInfoService
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class GetPastImageInfoService extends PlessJsonResponderSub<GetPastImageInfoResponse> {

  private imageFileName: string;

  /**
   * API成功時後続処理
   *
   * @private
   * @type {Function}
   * @memberof GetPastImageInfoService
   */
  private successFunc: Function;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof GetPastImageInfoService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      parameter: {
        ImageFileName: this.imageFileName
      }
    });
  }

  /**
   * API呼び出し
   *
   * @param model
   * @param {Function} successFunc 成功時後続処理
   * @memberof GetPastImageInfoService
   */
  execute(imageFileName: string, successFunc: Function): void {
    this.imageFileName = imageFileName;
    this.successFunc = successFunc;
    this.send('getPastImageInfo', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof GetPastImageInfoService
   */
  success(data: GetPastImageInfoResponse): void {
    if (this.successFunc !== null) {
      this.successFunc(data);
    }
  }
}
